var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nps-bar-label"},[_c('div',{staticClass:"nbl-label-container",style:({ left: _vm.middlePercent + '%' })},[_c('div',{staticClass:"nbl-label"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }